'use client';

import * as React from 'react';
import type { TagSize, TagTone, TagVariant } from '../types';

export type TagCtx = {
  size: TagSize;
  tone: TagTone;
  variant: TagVariant;
  disabled?: boolean;
};

export const TagContext = React.createContext<TagCtx | null>(null);

export const useTagContext = () => {
  const ctx = React.useContext(TagContext);
  if (!ctx) throw new Error('Tag compound components must be used within <Tag.Root>.');
  return ctx;
};
